<div class="main">
  <div class="grid mt-0">
    <div class="col-10">
      <div class="custom-stepper">
        <div class="step" [class.completed]="currentStep > 1">
          <span class="circle">
            @if (currentStep > 1) {
              <span>✔</span>
            }
          </span>
        </div>

        <div class="line" [class.active]="currentStep >= 1">
          <span class="label">Receipt Details</span>
        </div>

        <div class="step" [class.completed]="currentStep > 2">
          <span class="circle">
            @if (currentStep > 2) {
              <span>✔</span>
            }
          </span>
        </div>

        <div class="line" [class.active]="currentStep >= 2">
          <span class="label">Buyer TIN</span>
        </div>

        <div class="step" [class.completed]="currentStep > 3">
          <span class="circle">
            @if (currentStep > 3) {
              <span>✔</span>
            }
          </span>
        </div>

        <div class="line" [class.active]="currentStep >= 3">
          <span class="label">Buyer Details</span>
        </div>
      </div>
    </div>
    <div class="col-2">
      <button
        type="button"
        class="ey-secondary-dark me-2 mt-0"
        (click)="showConfirmationDialog()"
        pTooltip="Click to clear all entered data and begin a fresh."
        tooltipPosition="right"
      >
        Reset Form
      </button>
    </div>
  </div>
  <!-- (click)="showConfirmationDialog()" -->
  <div class="mt-2">
    <p-accordion [multiple]="true" [value]="activeIndex">
      @if (sectionVisibility[0]) {
        <p-accordion-panel value="0">
        <p-accordion-header>
          <div class="header-container">
            <span class="header-left">Receipt Details</span>
            @if (sellerLegalName) {
              <span
                class="header-center"
                [pTooltip]="sellerLegalName"
                tooltipPosition="top"
              >
                Seller Name: {{ truncateText(sellerLegalName, 50) }}
              </span>
            }
          </div>
        </p-accordion-header>
        <p-accordion-content>
          <app-receipt-details
            (formSubmitted)="onFormSubmit($event)"
          ></app-receipt-details>
        </p-accordion-content>
        </p-accordion-panel>
      }
      @if (sectionVisibility[1]) {
        <p-accordion-panel value="1">
        <p-accordion-header>Buyer TIN</p-accordion-header>
        <p-accordion-content>
          <app-buyer-tin
            (formSubmitted)="onFormSubmit(2)"
            [sellerBRN]="this.formData?.receiptDetails?.sellerBRN"
          ></app-buyer-tin>
        </p-accordion-content>
        </p-accordion-panel>
      }

      @if (sectionVisibility[2]) {
        <p-accordion-panel value="2">
        <p-accordion-header>Buyer Details</p-accordion-header>
        <p-accordion-content>
          <app-buyer-details
            [receiptDetails]="sharedReceiptData"
            (formSubmitted)="onFormSubmit(3)"
          ></app-buyer-details>
        </p-accordion-content>
        </p-accordion-panel>
      }
    </p-accordion>
  </div>
</div>
